var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSolInfoRequests01 = function SvgSolInfoRequests01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sol_info_requests-01_svg2__a",
    x1: 72.96,
    x2: 182.51,
    y1: 196.21,
    y2: 5.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3D43C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#5934b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#7523a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#89179f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#9b0d98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_info_requests-01_svg2__a",
    id: "sol_info_requests-01_svg2__b",
    x1: 22.21,
    x2: 131.76,
    y1: 167,
    y2: -23.3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_info_requests-01_svg2__a",
    id: "sol_info_requests-01_svg2__c",
    x1: 51.43,
    x2: 160.99,
    y1: 183.83,
    y2: -6.48
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_info_requests-01_svg2__a",
    id: "sol_info_requests-01_svg2__d",
    x1: 70.17,
    x2: 179.72,
    y1: 194.61,
    y2: 4.3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_info_requests-01_svg2__a",
    id: "sol_info_requests-01_svg2__e",
    x1: 64.4,
    x2: 173.95,
    y1: 191.29,
    y2: 0.98
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m185.59 143.14-50.97 17.88c-.75.26-1.53.39-2.32.38h-.79c1.02-3.63.55-7.51-1.3-10.79l-.26-.47a17.08 17.08 0 0 0-14.71-8.64h-14.4c-4.96-.03-9.76-1.81-13.55-5.02-5-4.19-11.3-6.49-17.82-6.52h-1.69c-.84 0-17.92.16-28.95 9.56a6.65 6.65 0 0 0-5.49-2.89H6.69c-3.68 0-6.66 2.99-6.67 6.67v46.66c0 3.68 2.99 6.66 6.67 6.67h26.66c1.99 0 3.87-.91 5.12-2.45a33.5 33.5 0 0 0 20.56 5.79h72.38c4.2-.01 8.3-1.22 11.84-3.47l51.6-33.07a11.33 11.33 0 0 0 4.91-7.38c.6-3.12-.09-6.35-1.92-8.95a10.8 10.8 0 0 0-12.25-3.96M33.35 189.96H6.69V143.3h26.66zm159.87-35.17a4.58 4.58 0 0 1-1.97 3.03l-51.56 33.04a15.53 15.53 0 0 1-8.27 2.43H59.03c-12.74 0-17.7-5.01-19.02-6.71v-38.67c8.14-11.1 27.58-11.28 27.77-11.28h1.69c4.96.02 9.75 1.78 13.55 4.97 4.99 4.21 11.3 6.53 17.82 6.57h14.4c3.69 0 7.09 2 8.89 5.23l.26.47a7.43 7.43 0 0 1-.17 7.54h-16.4a27.3 27.3 0 0 0-15.64 4.99l-2 1.4c-.97.68-1.51 1.84-1.41 3.02.11 1.19.83 2.23 1.91 2.73s2.34.39 3.32-.29l1.99-1.4c3.46-2.45 7.59-3.77 11.82-3.79h24.48c1.56 0 3.1-.25 4.57-.77l50.89-17.86a4.07 4.07 0 0 1 4.65 1.53c.77 1.11 1.06 2.49.8 3.81Z",
    style: {
      fill: "url(#sol_info_requests-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.68 179.96c.88-.01 1.73-.36 2.37-.97.29-.32.53-.7.7-1.1s.26-.83.27-1.27c-.01-.88-.36-1.73-.97-2.37a3.493 3.493 0 0 0-4.73 0c-.96.95-1.25 2.39-.73 3.64a3.35 3.35 0 0 0 3.1 2.06Z",
    style: {
      fill: "url(#sol_info_requests-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.99 39.99c5.52 0 10-4.48 10-10s-4.48-10-10-10-10 4.48-10 10 4.48 9.99 10 10m0-13.33c1.84 0 3.33 1.49 3.33 3.33s-1.49 3.33-3.33 3.33-3.33-1.49-3.33-3.33 1.49-3.33 3.33-3.33",
    style: {
      fill: "url(#sol_info_requests-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.66 99.98h26.66a3.346 3.346 0 0 0 3.34-3.34V83.31a3.346 3.346 0 0 0-3.34-3.34h-3.33V49.98a3.346 3.346 0 0 0-3.34-3.34h-20a3.346 3.346 0 0 0-3.34 3.34v13.33a3.346 3.346 0 0 0 3.34 3.34h3.33v13.33h-3.33a3.346 3.346 0 0 0-3.34 3.34v13.33c0 .88.35 1.73.98 2.36.63.62 1.47.98 2.36.98Zm3.33-13.33h3.33a3.346 3.346 0 0 0 3.34-3.34v-20a3.346 3.346 0 0 0-3.34-3.34h-3.33V53.3h13.33v29.99a3.346 3.346 0 0 0 3.34 3.34h3.33v6.67h-20v-6.66Z",
    style: {
      fill: "url(#sol_info_requests-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.33 107.45v19.19c0 1.28.73 2.44 1.88 3s2.52.41 3.52-.39l14.66-11.61c22.53 6.49 46.78-.75 62.07-18.52s18.83-42.83 9.05-64.14C184.74 13.66 163.44 0 139.99 0 114.33 0 91.5 16.32 83.22 40.61c-8.29 24.29-.2 51.16 20.12 66.84Zm-10.77-71.7c11.93-23.34 39.06-34.54 63.98-26.41s40.23 33.16 36.11 59.05c-4.12 25.88-26.45 44.93-52.66 44.92-5.52 0-11.01-.85-16.27-2.54a3.36 3.36 0 0 0-3.1.56l-10.63 8.42v-13.97c0-1.07-.51-2.07-1.38-2.7-21.18-15.44-27.99-43.99-16.06-67.33Z",
    style: {
      fill: "url(#sol_info_requests-01_svg2__e)"
    }
  }));
};
export default SvgSolInfoRequests01;